import * as StackTrace from "stacktrace-js";
import axios from "axios";

const hostName = `https://${window.location.hostname}`;
export const logUrl = `${process.env.API_BASE_URL || hostName}/api/logerror`;

const axiosInstance = axios.create({
  withCredentials: true,
  xsrfCookieName: "csrf-token",
  xsrfHeaderName: "x-csrf-token",
});

/**
 * Error handler that uses stacktrace.js to generate stacktrace and send it to backend.
 *
 * @param {Error} error
 * @param {string} cause
 */
const errorHandler = (error: Error, cause?: string) => {
  try {
    StackTrace.fromError(error)
      .then((stack) => {
        return axiosInstance
          .post(logUrl, { stack, message: cause || error.message })
          .catch(console.error);
      })
      .catch(console.error);
  } catch (error2) {
    console.error(error2);
  }
};

export default errorHandler;
